module.exports = __webpack_public_path__ + "static/media/glbl-03.21c6b190.png";